<template>
  <g>
    <g transform="scale(0.45)">
        <text transform="matrix(1 0 0 1 70 50)" class="name"
            >릴레이{{ number }}</text
        >
        <path
            class="st0"
            d="M88,352c-16.54,0-30-13.46-30-30V91c0-16.54,13.46-30,30-30h305c16.54,0,30,13.46,30,30v55h6.44v7h45.06
        c4.14,0,7.5,3.36,7.5,7.5s-3.36,7.5-7.5,7.5h-45.06v11h45.06c4.14,0,7.5,3.36,7.5,7.5s-3.36,7.5-7.5,7.5h-45.06v12h45.06
        c4.14,0,7.5,3.36,7.5,7.5s-3.36,7.5-7.5,7.5h-45.06v6H423v95c0,16.54-13.46,30-30,30H88z M393,304c-8.82,0-16,7.18-16,16
        s7.18,16,16,16s16-7.18,16-16S401.82,304,393,304z M88,304c-8.82,0-16,7.18-16,16s7.18,16,16,16s16-7.18,16-16S96.82,304,88,304z
        M393,76c-8.82,0-16,7.18-16,16s7.18,16,16,16s16-7.18,16-16S401.82,76,393,76z M88,76c-8.82,0-16,7.18-16,16s7.18,16,16,16
        s16-7.18,16-16S96.82,76,88,76z"
        />
        <g>
            <path
                class="st1"
                d="M393,64H88c-14.91,0-27,12.09-27,27v231c0,14.91,12.09,27,27,27h305c14.91,0,27-12.09,27-27V91
            C420,76.09,407.91,64,393,64z M88,339c-10.49,0-19-8.51-19-19s8.51-19,19-19s19,8.51,19,19S98.49,339,88,339z M88,111
            c-10.49,0-19-8.51-19-19s8.51-19,19-19s19,8.51,19,19S98.49,111,88,111z M393,339c-10.49,0-19-8.51-19-19s8.51-19,19-19
            s19,8.51,19,19S403.49,339,393,339z M393,111c-10.49,0-19-8.51-19-19s8.51-19,19-19s19,8.51,19,19S403.49,111,393,111z"
            />
            <g>
                <path
                    class="st2"
                    d="M153.25,128.75v163.78H97.82V128.75H153.25 M154,128H97.07v165.28H154V128L154,128z"
                />
            </g>
            <g>
                <path
                    class="st2"
                    d="M280.6,294.75v43.71h-99.85v-43.71H280.6 M281.35,294H180v45.21h101.35V294L281.35,294z"
                />
            </g>
            <g>
                <path
                    class="st2"
                    d="M350.25,294.75v43.5h-21.5v-43.5H350.25 M351,294h-23v45h23V294L351,294z"
                />
            </g>
        </g>
        <rect x="256.91" y="301.89" class="st2" width="12.61" height="29.43" />
        <rect x="193" y="301.89" class="st2" width="12.61" height="29.43" />
        <path
            class="st4"
            d="M260.07,335.54h-57.13c-1.66,0-3-1.34-3-3v-32.21c0-1.66,1.34-3,3-3h57.13c1.66,0,3,1.34,3,3v32.21
        C263.07,334.19,261.73,335.54,260.07,335.54z"
        />
        <rect x="209.91" y="297.5" class="st5" width="8.31" height="38.21" />
        <g>
            <path
                class="st5"
                d="M237.09,316.55c-0.1-1.88-0.22-4.13-0.2-5.8h-0.06c-0.46,1.58-1.02,3.25-1.69,5.11l-2.37,6.52h-1.32l-2.17-6.4
            c-0.64-1.89-1.18-3.63-1.56-5.23h-0.04c-0.04,1.68-0.14,3.93-0.26,5.94l-0.36,5.76h-1.66l0.94-13.44h2.21l2.29,6.5
            c0.56,1.66,1.02,3.13,1.36,4.53h0.06c0.34-1.36,0.82-2.83,1.42-4.53l2.39-6.5h2.21l0.84,13.44h-1.69L237.09,316.55z"
            />
            <path
                class="st5"
                d="M249.59,309.49v1.16l-5.64,11.81h-1.81l5.62-11.47v-0.04h-6.34v-1.46H249.59z"
            />
        </g>
        <rect x="331.74" y="298" class="st5" width="15.26" height="37" />
        <rect x="331.74" y="319.74" class="st4" width="15.26" height="15.26" />
        <g>
            <rect x="88" y="134" class="st6" width="70" height="153" />
            <rect x="146" y="134" class="st7" width="15" height="153" />
            <rect x="101" y="179.5" class="st7" width="36" height="7" />
            <rect x="101" y="233.5" class="st7" width="36" height="7" />
            <circle class="st7" cx="120" cy="156" r="16" />
            <circle class="st7" cx="120" cy="210" r="16" />
            <circle class="st7" cx="120" cy="264" r="16" />
            <g>
                <circle class="st8" cx="120" cy="264" r="12" />
                <polygon
                    class="st5"
                    points="126.96,259.82 124.18,257.04 120,261.22 115.82,257.04 113.04,259.82 117.22,264 113.04,268.18
                115.82,270.96 120,266.78 124.18,270.96 126.96,268.18 122.78,264"
                />
            </g>
            <g>
                <circle class="st8" cx="120" cy="210" r="12" />
                <polygon
                    class="st5"
                    points="126.96,205.82 124.18,203.04 120,207.22 115.82,203.04 113.04,205.82 117.22,210 113.04,214.18
                115.82,216.96 120,212.78 124.18,216.96 126.96,214.18 122.78,210"
                />
            </g>
            <g>
                <circle class="st8" cx="120" cy="156" r="12" />
                <polygon
                    class="st5"
                    points="126.96,151.82 124.18,149.04 120,153.22 115.82,149.04 113.04,151.82 117.22,156 113.04,160.18
                115.82,162.96 120,158.78 124.18,162.96 126.96,160.18 122.78,156"
                />
            </g>
        </g>
        <rect x="331.74" y="298" class="st5" width="15.26" height="37" />
        <rect x="331.74" y="319.74" class="st4" width="15.26" height="15.26" />
        <g>
            <path
                class="st9"
                d="M360.75,270h-190c-1.66,0-3-1.34-3-3V108.33c0-1.66,1.34-3,3-3h190c1.66,0,3,1.34,3,3V267
            C363.75,268.66,362.41,270,360.75,270z"
            />
            <g>
                <path
                    class="st2"
                    d="M183.67,253.81c0.94,0.58,2.3,1.06,3.74,1.06c2.14,0,3.38-1.13,3.38-2.76c0-1.51-0.86-2.38-3.05-3.22
                c-2.64-0.94-4.27-2.3-4.27-4.58c0-2.52,2.09-4.39,5.23-4.39c1.66,0,2.86,0.38,3.58,0.79l-0.58,1.7c-0.53-0.29-1.61-0.77-3.07-0.77
                c-2.21,0-3.05,1.32-3.05,2.42c0,1.51,0.98,2.26,3.22,3.12c2.74,1.06,4.13,2.38,4.13,4.75c0,2.5-1.85,4.66-5.66,4.66
                c-1.56,0-3.26-0.46-4.13-1.03L183.67,253.81z"
                />
                <path
                    class="st2"
                    d="M195.79,240.4c1.06-0.22,2.57-0.34,4.01-0.34c2.23,0,3.67,0.41,4.68,1.32c0.82,0.72,1.27,1.82,1.27,3.07
                c0,2.14-1.34,3.55-3.05,4.13v0.07c1.25,0.43,1.99,1.58,2.38,3.26c0.53,2.26,0.91,3.82,1.25,4.44h-2.16
                c-0.26-0.46-0.62-1.85-1.08-3.86c-0.48-2.23-1.34-3.07-3.24-3.14h-1.97v7.01h-2.09V240.4z M197.88,247.76h2.14
                c2.23,0,3.65-1.22,3.65-3.07c0-2.09-1.51-3-3.72-3.02c-1.01,0-1.73,0.1-2.06,0.19V247.76z"
                />
                <path
                    class="st2"
                    d="M208.71,240.4c1.27-0.19,2.78-0.34,4.44-0.34c3,0,5.14,0.7,6.55,2.02c1.44,1.32,2.28,3.19,2.28,5.81
                c0,2.64-0.82,4.8-2.33,6.29c-1.51,1.51-4.01,2.33-7.15,2.33c-1.49,0-2.74-0.07-3.79-0.19V240.4z M210.79,254.7
                c0.53,0.1,1.3,0.12,2.11,0.12c4.46,0,6.89-2.5,6.89-6.86c0.02-3.82-2.14-6.24-6.55-6.24c-1.08,0-1.9,0.1-2.45,0.22V254.7z"
                />
                <path class="st2" d="M229.85,249.08v1.56h-5.93v-1.56H229.85z" />
                <path
                    class="st2"
                    d="M242.02,248.39c0,5.3-1.97,8.23-5.42,8.23c-3.05,0-5.11-2.86-5.16-8.02c0-5.23,2.26-8.11,5.42-8.11
                C240.15,240.49,242.02,243.42,242.02,248.39z M233.54,248.63c0,4.06,1.25,6.36,3.17,6.36c2.16,0,3.19-2.52,3.19-6.5
                c0-3.84-0.98-6.36-3.17-6.36C234.89,242.12,233.54,244.38,233.54,248.63z"
                />
                <path
                    class="st2"
                    d="M253.27,242.53h-5.95l-0.6,4.01c0.36-0.05,0.7-0.1,1.27-0.1c1.2,0,2.4,0.26,3.36,0.84
                c1.22,0.7,2.23,2.04,2.23,4.01c0,3.05-2.42,5.33-5.81,5.33c-1.7,0-3.14-0.48-3.89-0.96l0.53-1.61c0.65,0.38,1.92,0.86,3.34,0.86
                c1.99,0,3.7-1.3,3.7-3.38c-0.02-2.02-1.37-3.46-4.49-3.46c-0.89,0-1.58,0.1-2.16,0.17l1.01-7.49h7.46V242.53z"
                />
                <path
                    class="st2"
                    d="M260.57,256.36l-5.28-16.18h2.26l2.52,7.97c0.7,2.18,1.3,4.15,1.73,6.05h0.05c0.46-1.87,1.13-3.91,1.85-6.02
                l2.74-7.99h2.23l-5.78,16.18H260.57z"
                />
                <path
                    class="st2"
                    d="M270.41,240.4c1.27-0.19,2.78-0.34,4.44-0.34c3,0,5.14,0.7,6.55,2.02c1.44,1.32,2.28,3.19,2.28,5.81
                c0,2.64-0.82,4.8-2.33,6.29c-1.51,1.51-4.01,2.33-7.15,2.33c-1.49,0-2.74-0.07-3.79-0.19V240.4z M272.5,254.7
                c0.53,0.1,1.3,0.12,2.11,0.12c4.46,0,6.89-2.5,6.89-6.86c0.02-3.82-2.14-6.24-6.55-6.24c-1.08,0-1.9,0.1-2.45,0.22V254.7z"
                />
                <path
                    class="st2"
                    d="M297.7,255.83c-0.77,0.38-2.3,0.77-4.27,0.77c-4.56,0-7.99-2.88-7.99-8.18c0-5.06,3.43-8.5,8.45-8.5
                c2.02,0,3.29,0.43,3.84,0.72l-0.5,1.7c-0.79-0.38-1.92-0.67-3.26-0.67c-3.79,0-6.31,2.42-6.31,6.67c0,3.96,2.28,6.5,6.22,6.5
                c1.27,0,2.57-0.26,3.41-0.67L297.7,255.83z"
                />
                <path class="st2" d="M305.13,249.08v1.56h-5.93v-1.56H305.13z" />
                <path
                    class="st2"
                    d="M307.39,253.81c0.94,0.58,2.3,1.06,3.74,1.06c2.14,0,3.38-1.13,3.38-2.76c0-1.51-0.86-2.38-3.05-3.22
                c-2.64-0.94-4.27-2.3-4.27-4.58c0-2.52,2.09-4.39,5.23-4.39c1.66,0,2.86,0.38,3.58,0.79l-0.58,1.7c-0.53-0.29-1.61-0.77-3.07-0.77
                c-2.21,0-3.05,1.32-3.05,2.42c0,1.51,0.98,2.26,3.22,3.12c2.74,1.06,4.13,2.38,4.13,4.75c0,2.5-1.85,4.66-5.67,4.66
                c-1.56,0-3.26-0.46-4.13-1.03L307.39,253.81z"
                />
                <path
                    class="st2"
                    d="M319.51,240.18h2.09v14.43h6.91v1.75h-9V240.18z"
                />
                <path class="st2" d="M334.65,249.08v1.56h-5.93v-1.56H334.65z" />
                <path
                    class="st2"
                    d="M348.84,255.83c-0.77,0.38-2.3,0.77-4.27,0.77c-4.56,0-7.99-2.88-7.99-8.18c0-5.06,3.43-8.5,8.45-8.5
                c2.02,0,3.29,0.43,3.84,0.72l-0.5,1.7c-0.79-0.38-1.92-0.67-3.26-0.67c-3.79,0-6.31,2.42-6.31,6.67c0,3.96,2.28,6.5,6.22,6.5
                c1.27,0,2.57-0.26,3.41-0.67L348.84,255.83z"
                />
            </g>
            <circle class="st10" cx="339.5" cy="129.5" r="10.5" />
            <circle class="st10" cx="265.75" cy="162.5" r="10.5" />
            <g>
                <path
                    class="st2"
                    d="M185.87,199.36h-0.03l-1.81,0.98l-0.27-1.07l2.27-1.22h1.2v10.4h-1.36V199.36z"
                />
                <path
                    class="st2"
                    d="M197.78,203.14c0,3.54-1.31,5.49-3.62,5.49c-2.03,0-3.41-1.9-3.44-5.35c0-3.49,1.5-5.41,3.62-5.41
                C196.53,197.87,197.78,199.82,197.78,203.14z M192.13,203.3c0,2.71,0.83,4.24,2.11,4.24c1.44,0,2.13-1.68,2.13-4.34
                c0-2.56-0.66-4.24-2.11-4.24C193.02,198.96,192.13,200.46,192.13,203.3z"
                />
                <path
                    class="st2"
                    d="M201.15,205.06l-1.12,3.39h-1.44l3.67-10.79h1.68l3.68,10.79h-1.49l-1.15-3.39H201.15z M204.69,203.97
                l-1.06-3.11c-0.24-0.7-0.4-1.34-0.56-1.97h-0.03c-0.16,0.64-0.34,1.3-0.54,1.95l-1.06,3.12H204.69z"
                />
                <path
                    class="st2"
                    d="M211.78,208.45v-0.86l1.1-1.07c2.66-2.53,3.86-3.87,3.87-5.44c0-1.06-0.51-2.03-2.06-2.03
                c-0.94,0-1.73,0.48-2.21,0.88l-0.45-0.99c0.72-0.61,1.74-1.06,2.94-1.06c2.24,0,3.19,1.54,3.19,3.03c0,1.92-1.39,3.47-3.59,5.59
                l-0.83,0.77v0.03h4.67v1.17H211.78z"
                />
                <path
                    class="st2"
                    d="M226.03,199.23h-3.97l-0.4,2.67c0.24-0.03,0.46-0.06,0.85-0.06c0.8,0,1.6,0.18,2.24,0.56
                c0.82,0.46,1.49,1.36,1.49,2.67c0,2.03-1.62,3.55-3.87,3.55c-1.14,0-2.1-0.32-2.59-0.64l0.35-1.07c0.43,0.26,1.28,0.58,2.23,0.58
                c1.33,0,2.46-0.87,2.46-2.26c-0.02-1.34-0.91-2.3-2.99-2.3c-0.59,0-1.06,0.06-1.44,0.11l0.67-4.99h4.98V199.23z"
                />
                <path
                    class="st2"
                    d="M234.79,203.14c0,3.54-1.31,5.49-3.62,5.49c-2.03,0-3.41-1.9-3.44-5.35c0-3.49,1.5-5.41,3.62-5.41
                C233.54,197.87,234.79,199.82,234.79,203.14z M229.14,203.3c0,2.71,0.83,4.24,2.11,4.24c1.44,0,2.13-1.68,2.13-4.34
                c0-2.56-0.66-4.24-2.11-4.24C230.03,198.96,229.14,200.46,229.14,203.3z"
                />
                <path
                    class="st2"
                    d="M238.78,208.45l-3.52-10.79h1.5l1.68,5.31c0.46,1.46,0.86,2.77,1.15,4.03h0.03c0.3-1.25,0.75-2.61,1.23-4.02
                l1.82-5.33h1.49l-3.86,10.79H238.78z"
                />
                <path
                    class="st2"
                    d="M246.02,205.06l-1.12,3.39h-1.44l3.67-10.79h1.68l3.68,10.79h-1.49l-1.15-3.39H246.02z M249.55,203.97
                l-1.06-3.11c-0.24-0.7-0.4-1.34-0.56-1.97h-0.03c-0.16,0.64-0.34,1.3-0.54,1.95l-1.06,3.12H249.55z"
                />
                <path
                    class="st2"
                    d="M261.2,208.1c-0.51,0.26-1.54,0.51-2.85,0.51c-3.04,0-5.33-1.92-5.33-5.46c0-3.38,2.29-5.67,5.63-5.67
                c1.34,0,2.19,0.29,2.56,0.48l-0.34,1.14c-0.53-0.26-1.28-0.45-2.18-0.45c-2.53,0-4.21,1.62-4.21,4.45c0,2.64,1.52,4.34,4.15,4.34
                c0.85,0,1.71-0.18,2.27-0.45L261.2,208.1z"
                />
            </g>
            <g>
                <path
                    class="st2"
                    d="M185.87,219.36h-0.03l-1.81,0.98l-0.27-1.07l2.27-1.22h1.2v10.4h-1.36V219.36z"
                />
                <path
                    class="st2"
                    d="M197.78,223.14c0,3.54-1.31,5.49-3.62,5.49c-2.03,0-3.41-1.9-3.44-5.35c0-3.49,1.5-5.41,3.62-5.41
                C196.53,217.87,197.78,219.82,197.78,223.14z M192.13,223.3c0,2.71,0.83,4.24,2.11,4.24c1.44,0,2.13-1.68,2.13-4.34
                c0-2.56-0.66-4.24-2.11-4.24C193.02,218.96,192.13,220.46,192.13,223.3z"
                />
                <path
                    class="st2"
                    d="M201.15,225.06l-1.12,3.39h-1.44l3.67-10.79h1.68l3.68,10.79h-1.49l-1.15-3.39H201.15z M204.69,223.97
                l-1.06-3.11c-0.24-0.7-0.4-1.34-0.56-1.97h-0.03c-0.16,0.64-0.34,1.3-0.54,1.95l-1.06,3.12H204.69z"
                />
                <path
                    class="st2"
                    d="M218.58,226.84c0.4,0.26,1.33,0.66,2.3,0.66c1.81,0,2.37-1.15,2.35-2.02c-0.02-1.46-1.33-2.08-2.69-2.08
                h-0.78v-1.06h0.78c1.02,0,2.32-0.53,2.32-1.76c0-0.83-0.53-1.57-1.82-1.57c-0.83,0-1.63,0.37-2.08,0.69l-0.37-1.02
                c0.54-0.4,1.6-0.8,2.72-0.8c2.05,0,2.98,1.22,2.98,2.48c0,1.07-0.64,1.99-1.92,2.45v0.03c1.28,0.26,2.32,1.22,2.32,2.67
                c0,1.67-1.3,3.12-3.79,3.12c-1.17,0-2.19-0.37-2.71-0.7L218.58,226.84z"
                />
                <path
                    class="st2"
                    d="M233.2,223.14c0,3.54-1.31,5.49-3.62,5.49c-2.03,0-3.41-1.9-3.44-5.35c0-3.49,1.5-5.41,3.62-5.41
                C231.95,217.87,233.2,219.82,233.2,223.14z M227.55,223.3c0,2.71,0.83,4.24,2.11,4.24c1.44,0,2.13-1.68,2.13-4.34
                c0-2.56-0.66-4.24-2.11-4.24C228.45,218.96,227.55,220.46,227.55,223.3z"
                />
                <path
                    class="st2"
                    d="M237.2,228.45l-3.52-10.79h1.5l1.68,5.31c0.46,1.46,0.86,2.77,1.15,4.03h0.03c0.3-1.25,0.75-2.61,1.23-4.02
                l1.82-5.33h1.49l-3.86,10.79H237.2z"
                />
                <path
                    class="st2"
                    d="M244.43,225.06l-1.12,3.39h-1.44l3.67-10.79h1.68l3.68,10.79h-1.49l-1.15-3.39H244.43z M247.97,223.97
                l-1.06-3.11c-0.24-0.7-0.4-1.34-0.56-1.97h-0.03c-0.16,0.64-0.34,1.3-0.54,1.95l-1.06,3.12H247.97z"
                />
                <path
                    class="st2"
                    d="M259.62,228.1c-0.51,0.26-1.54,0.51-2.85,0.51c-3.04,0-5.33-1.92-5.33-5.46c0-3.38,2.29-5.67,5.63-5.67
                c1.34,0,2.19,0.29,2.56,0.48l-0.34,1.14c-0.53-0.26-1.28-0.45-2.18-0.45c-2.53,0-4.21,1.62-4.21,4.45c0,2.64,1.52,4.34,4.15,4.34
                c0.85,0,1.71-0.18,2.27-0.45L259.62,228.1z"
                />
            </g>
            <g>
                <path
                    class="st2"
                    d="M274.87,199.36h-0.03l-1.81,0.98l-0.27-1.07l2.27-1.22h1.2v10.4h-1.36V199.36z"
                />
                <path
                    class="st2"
                    d="M286.78,203.14c0,3.54-1.31,5.49-3.62,5.49c-2.03,0-3.41-1.9-3.44-5.35c0-3.49,1.5-5.41,3.62-5.41
                C285.53,197.87,286.78,199.82,286.78,203.14z M281.13,203.3c0,2.71,0.83,4.24,2.11,4.24c1.44,0,2.13-1.68,2.13-4.34
                c0-2.56-0.66-4.24-2.11-4.24C282.02,198.96,281.13,200.46,281.13,203.3z"
                />
                <path
                    class="st2"
                    d="M290.15,205.06l-1.12,3.39h-1.44l3.67-10.79h1.68l3.68,10.79h-1.49l-1.15-3.39H290.15z M293.69,203.97
                l-1.06-3.11c-0.24-0.7-0.4-1.34-0.56-1.97h-0.03c-0.16,0.64-0.34,1.3-0.54,1.95l-1.06,3.12H293.69z"
                />
                <path
                    class="st2"
                    d="M303.83,199.36h-0.03l-1.81,0.98l-0.27-1.07l2.27-1.22h1.2v10.4h-1.36V199.36z"
                />
                <path
                    class="st2"
                    d="M308.82,208.45v-0.86l1.1-1.07c2.66-2.53,3.86-3.87,3.87-5.44c0-1.06-0.51-2.03-2.06-2.03
                c-0.94,0-1.73,0.48-2.21,0.88l-0.45-0.99c0.72-0.61,1.74-1.06,2.94-1.06c2.24,0,3.19,1.54,3.19,3.03c0,1.92-1.39,3.47-3.58,5.59
                l-0.83,0.77v0.03h4.67v1.17H308.82z"
                />
                <path
                    class="st2"
                    d="M323.08,199.23h-3.97l-0.4,2.67c0.24-0.03,0.46-0.06,0.85-0.06c0.8,0,1.6,0.18,2.24,0.56
                c0.82,0.46,1.49,1.36,1.49,2.67c0,2.03-1.62,3.55-3.87,3.55c-1.14,0-2.1-0.32-2.59-0.64l0.35-1.07c0.43,0.26,1.28,0.58,2.23,0.58
                c1.33,0,2.46-0.87,2.46-2.26c-0.02-1.34-0.91-2.3-2.99-2.3c-0.59,0-1.06,0.06-1.44,0.11l0.67-4.99h4.98V199.23z"
                />
                <path
                    class="st2"
                    d="M327.78,208.45l-3.52-10.79h1.51l1.68,5.31c0.46,1.46,0.87,2.77,1.15,4.03h0.03c0.3-1.25,0.75-2.61,1.23-4.02
                l1.82-5.33h1.49l-3.86,10.79H327.78z"
                />
                <path
                    class="st2"
                    d="M335.02,205.06l-1.12,3.39h-1.44l3.67-10.79h1.68l3.68,10.79h-1.49l-1.15-3.39H335.02z M338.55,203.97
                l-1.06-3.11c-0.24-0.7-0.4-1.34-0.56-1.97h-0.03c-0.16,0.64-0.34,1.3-0.54,1.95l-1.06,3.12H338.55z"
                />
                <path
                    class="st2"
                    d="M350.2,208.1c-0.51,0.26-1.54,0.51-2.85,0.51c-3.04,0-5.33-1.92-5.33-5.46c0-3.38,2.29-5.67,5.63-5.67
                c1.35,0,2.19,0.29,2.56,0.48l-0.34,1.14c-0.53-0.26-1.28-0.45-2.18-0.45c-2.53,0-4.21,1.62-4.21,4.45c0,2.64,1.52,4.34,4.15,4.34
                c0.85,0,1.71-0.18,2.27-0.45L350.2,208.1z"
                />
            </g>
            <g>
                <path
                    class="st2"
                    d="M276.87,219.36h-0.03l-1.81,0.98l-0.27-1.07l2.27-1.22h1.2v10.4h-1.36V219.36z"
                />
                <path
                    class="st2"
                    d="M288.78,223.14c0,3.54-1.31,5.49-3.62,5.49c-2.03,0-3.41-1.9-3.44-5.35c0-3.49,1.5-5.41,3.62-5.41
                C287.53,217.87,288.78,219.82,288.78,223.14z M283.13,223.3c0,2.71,0.83,4.24,2.11,4.24c1.44,0,2.13-1.68,2.13-4.34
                c0-2.56-0.66-4.24-2.11-4.24C284.02,218.96,283.13,220.46,283.13,223.3z"
                />
                <path
                    class="st2"
                    d="M292.15,225.06l-1.12,3.39h-1.44l3.67-10.79h1.68l3.68,10.79h-1.49l-1.15-3.39H292.15z M295.69,223.97
                l-1.06-3.11c-0.24-0.7-0.4-1.34-0.56-1.97h-0.03c-0.16,0.64-0.34,1.3-0.54,1.95l-1.06,3.12H295.69z"
                />
                <path
                    class="st2"
                    d="M309.24,228.45v-0.86l1.11-1.07c2.66-2.53,3.86-3.87,3.87-5.44c0-1.06-0.51-2.03-2.06-2.03
                c-0.95,0-1.73,0.48-2.21,0.88l-0.45-0.99c0.72-0.61,1.75-1.06,2.94-1.06c2.24,0,3.19,1.54,3.19,3.03c0,1.92-1.39,3.47-3.58,5.59
                l-0.83,0.77v0.03h4.67v1.17H309.24z"
                />
                <path
                    class="st2"
                    d="M317.16,225.81c0-1.31,0.79-2.24,2.07-2.79l-0.02-0.05c-1.15-0.54-1.65-1.44-1.65-2.34
                c0-1.65,1.39-2.77,3.22-2.77c2.02,0,3.03,1.26,3.03,2.56c0,0.88-0.43,1.83-1.71,2.43v0.05c1.3,0.51,2.1,1.42,2.1,2.69
                c0,1.81-1.55,3.03-3.54,3.03C318.47,228.63,317.16,227.33,317.16,225.81z M322.76,225.75c0-1.26-0.88-1.87-2.29-2.27
                c-1.22,0.35-1.87,1.15-1.87,2.14c-0.05,1.06,0.75,1.98,2.08,1.98C321.94,227.6,322.76,226.82,322.76,225.75z M318.89,220.54
                c0,1.04,0.79,1.6,1.99,1.92c0.9-0.3,1.58-0.94,1.58-1.89c0-0.83-0.5-1.7-1.76-1.7C319.53,218.88,318.89,219.65,318.89,220.54z"
                />
                <path
                    class="st2"
                    d="M328.2,228.45l-3.52-10.79h1.51l1.68,5.31c0.46,1.46,0.87,2.77,1.15,4.03h0.03c0.3-1.25,0.75-2.61,1.23-4.02
                l1.82-5.33h1.49l-3.86,10.79H328.2z"
                />
                <path
                    class="st2"
                    d="M335.43,225.06l-1.12,3.39h-1.44l3.66-10.79h1.68l3.68,10.79h-1.49l-1.15-3.39H335.43z M338.97,223.97
                l-1.06-3.11c-0.24-0.7-0.4-1.34-0.56-1.97h-0.03c-0.16,0.64-0.34,1.3-0.54,1.95l-1.06,3.12H338.97z"
                />
                <path
                    class="st2"
                    d="M350.62,228.1c-0.51,0.26-1.54,0.51-2.85,0.51c-3.04,0-5.33-1.92-5.33-5.46c0-3.38,2.29-5.67,5.63-5.67
                c1.35,0,2.19,0.29,2.56,0.48l-0.34,1.14c-0.53-0.26-1.28-0.45-2.18-0.45c-2.53,0-4.21,1.62-4.21,4.45c0,2.64,1.52,4.34,4.15,4.34
                c0.85,0,1.71-0.18,2.27-0.45L350.62,228.1z"
                />
            </g>
        </g>
        <!--terminal-->
        <g class="pin">
            <rect x="68" y="147" width="18" height="18" />
            <path
                class="st3"
                d="M88,167H66v-22h22V167z M70,163h14v-14H70V163z"
            />
            <rect
                :id="`${pincode}NO`"
                @click="onClick(`${pincode}NO`)"
                class="pin-cover terminal"
                x="64"
                y="145"
                width="25"
                height="25"
            />
            <text transform="matrix(1 0 0 1 0 165)" class="pin-name">NO</text>
        </g>
        <g class="pin">
            <rect x="68" y="200.5" width="18" height="18" />
            <path
                class="st3"
                d="M88,220.5H66v-22h22V220.5z M70,216.5h14v-14H70V216.5z"
            />
            <rect
                :id="`${pincode}CO`"
                @click="onClick(`${pincode}CO`)"
                class="pin-cover terminal"
                x="64"
                y="198.5"
                width="25"
                height="25"
            />
            <text transform="matrix(1 0 0 1 -20 220)" class="pin-name"
                >COM</text
            >
        </g>
        <g class="pin">
            <rect x="68" y="254" width="18" height="18" />
            <path
                class="st3"
                d="M88,274H66v-22h22V274z M70,270h14v-14H70V270z"
            />
            <rect
                :id="`${pincode}NC`"
                @click="onClick(`${pincode}NC`)"
                class="pin-cover terminal"
                x="64"
                y="252"
                width="25"
                height="25"
            />
            <text transform="matrix(1 0 0 1 0 275)" class="pin-name">NC</text>
        </g>
        <!--pin-->
        <g class="pin">
            <rect
                x="400.71"
                y="145.27"
                transform="matrix(6.123234e-17 -1 1 6.123234e-17 251.7124 571.7124)"
                class="st4"
                width="22"
                height="29.46"
            />
            <path
                class="st11"
                d="M475,165h-48.5v-9H475c2.49,0,4.5,2.01,4.5,4.5l0,0C479.5,162.99,477.49,165,475,165z"
            />
            <rect
                :id="`${pincode}MS`"
                @click="onClick(`${pincode}MS`)"
                class="pin-cover terminal snap"
                x="470"
                y="150"
                width="20"
                height="20"
            />
            <text transform="matrix(1 0 0 1 500 170)" class="pin-name">GND</text>
        </g>
        <g class="pin" style="transform: translate(0,15px)">
            <rect
                x="400.71"
                y="171.77"
                transform="matrix(6.123234e-17 -1 1 6.123234e-17 225.2124 598.2124)"
                class="st4"
                width="22"
                height="29.46"
            />
            <path
                class="st11"
                d="M475,191h-48.5v-9H475c2.49,0,4.5,2.01,4.5,4.5l0,0C479.5,188.99,477.49,191,475,191z"
            />
            <rect
                :id="`${pincode}PS`"
                @click="onClick(`${pincode}PS`)"
                class="pin-cover terminal snap"
                x="470"
                y="176.77"
                width="20"
                height="20"
            />
            <text transform="matrix(1 0 0 1 500 195)" class="pin-name"
                >VCC</text
            >
        </g>
        <g class="pin" style="transform: translate(0,35px)">
            <rect
                x="400.71"
                y="198.27"
                transform="matrix(6.123234e-17 -1 1 6.123234e-17 198.7124 624.7124)"
                class="st4"
                width="22"
                height="29.46"
            />
            <path
                class="st11"
                d="M475,218h-48.5v-9H475c2.49,0,4.5,2.01,4.5,4.5l0,0C479.5,215.99,477.49,218,475,218z"
            />
            <rect
                :id="`${pincode}SG`"
                @click="onClick(`${pincode}SG`)"
                class="pin-cover terminal snap"
                x="470"
                y="203.27"
                width="20"
                height="20"
            />
            <text transform="matrix(1 0 0 1 500 220)" class="pin-name"
                >SIG</text
            >
        </g>
    </g>
  </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  props: ['data'],
  mixins: [pins],
  name: 'Relay',
  data () {
    return {
      socket: null,
      on: false
    }
  },
  mounted () {
    this.setPindata(this.data)
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    start (socket) {
      this.socket = socket
      this.on = true
      this.socket.onmessage = ({ data }) => {
        console.log('Relay', data)
      }
    },
    off () {
      this.on = false
    }
  }
}
</script>

<style lang="scss" scoped>
.pin-cover {
    display: block;
    stroke: none;
    fill: none;
}
.pin-name {
    display: none;
    font-size: 32px;
}
.pin:hover {
    cursor: pointer;
    .pin-cover {
        stroke-width: 3px;
        stroke: black;
        fill: #ff6f61;
    }
    .pin-name {
        display: block;
    }
}
.selected {
    & path.st1 {
        stroke: #ff6f61;
        stroke-width: 4px;
    }
}
.name{
    font-size: 32px;
}
.st0 {
    fill: none;
}
.st1 {
    fill: #000101;
}
.st2 {
    fill: #ffffff;
}
.st3 {
    fill: #514e55;
}
.st4 {
    fill: #333333;
}
.st5 {
    fill: #666666;
}
.st6 {
    fill: #2470dd;
}
.st7 {
    fill: #022c80;
}
.st8 {
    fill: #b3b3b3;
}
.st9 {
    fill: #3080ca;
}
.st10 {
    fill: #2f75b8;
}
.st11 {
    fill: #808080;
}
</style>
